import React from 'react';
import Paper from '../../../../../../components/Paper';
import { makeStyles } from '../../../../../../utils/styles';
import Typography from '../../../../../../components/Typography';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(css => ({
    paper: css`
        margin-top: 10px;
        text-align: center;
    `,
    font: css`
        font-size: 24px;
        line-height: 32px;
    `
}));

const NoData = () => {
    const { t } = useTranslation()
    const styles = useStyles();

    return (
        <Paper customStyle={styles.paper}>
            <Typography customStyle={styles.font}>{t("Brak ocen")}</Typography>
        </Paper>
    )
}

export default NoData;
